import React, {Component} from 'react';
import {Modal, Toast} from "antd-mobile";
import {refund, getRefundcharge, changeCheck, cancelOrder,refundRun,refundRuncharge,goodsGetcharge,goodsOrderCancle} from "../../service/orderService";
import {
    newWxPay,
    busWxPay,
    cancelCityOrder,
    getCancelPic,
    shuttlePay,
    goodsPay,
    walletCode,
} from "../../service/homeService";
import PayModal from "../PayModal";
import "./style.less";
import TestCode from "../TestCode";
const car = require('../../../src/common/image/car.png');
const cityCar = require('../../../src/common/image/cityCar.png');
const baoche = require('../../../src/common/image/baoche.png');
const jiesong = require('../../../src/common/image/jiesong.png');

export default class OrderListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderId:"",
            payModal:false,
            payOrderId:"",
            formPay:"",
            payType:"",
            codeModal:false,
            getCodeDisabled: false,
            getCodeText: '重新获取',
        };
    }

    componentDidMount() {}

    goDetail = (orderNo, orderType) => {
        this.props.history.push(`/orderDetail/${orderNo}`, {orderType: orderType});
    };

    //去支付
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.goPay("icbcjft")
        }
        if(e== "微信支付"){
            this.goPay("wx")
        }
        if(e == "民途钱包余额支付"){
            if(this.state.getCodeText !== "重新获取"){
                Toast.info(this.state.getCodeText,3);
                return
            }
            this.getCode();
        }
    }
    goPay(type,v){
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: this.state.payOrderId,
                payChannel:type,
                smsCode:v,
            }
        };
        this.state.payType(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data);
                }else if(type == "wallet"){
                    this.props.paySuccess();
                    this.onClose();
                }else{
                    // window.location.href = res.data.data.qrcode;
                    this.onClose();
                    this.setState({formPay:res.data.data});
                }
            } else {
                Toast.info(res.data.msg);
            }
        });
    }
    wxBridgeReady = (bridgeInfo) => {
        const self = this;
        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    // alert(JSON.stringify(r));
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        self.props.paySuccess();
                        self.onClose();
                    } else if (r.err_msg == "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试');
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };


    goRefund = (order,type,chargeName) => {
        if(type === 'refund'){
            Toast.loading("",0);
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                   id:order,
                }
            };
            chargeName(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.hide();
                    Modal.alert('您是否确认退票？',
                        (<div className="refundText" style={{}}>
                            <p className="refundBox">本次退票将收取<span>{res.data.data.charge}</span>元手续费用 </p>
                            <p className="refundBox">1、申请取消订单时间距离发车时间超过24小时，不收手续费；</p>
                            <p className="refundBox">2、申请取消订单时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；</p>
                            <p className="refundBox">3、申请取消订单时间距离发车时间超过2小时且不足12小时，收取订单金额20%手续费；</p>
                            <p className="refundBox">4、申请取消订单时间距离发车时间不足2小时不可取消订单。</p>
                        </div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                        }, {
                            text: '确认',
                            onPress: () => this.refundApply(order,type,res.data.data.charge,chargeName),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                        }]
                    );
                }else{
                    Toast.info(res.data.msg,3)
                }
            });

        }
        if(type === 'change'){
            Modal.alert('您是否确认改签？',
                (<div className="refundText">
                    <div className="refundBox noPadding">改签将收取一定手续费</div>
                    <div className="refundBox noPadding">1、申请改签时间距离发车时间超过24小时，不收取手续费；</div>
                    <div className="refundBox noPadding">2、申请改签时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；</div>
                    <div className="refundBox noPadding">3、申请改签时间距离发车时间超过2小时且不足12小时，收取订单金额10%手续费；</div>
                    <div className="refundBox noPadding">4、申请改签时间距离发车时间不足2小时不支持改签。</div>
                </div>),
                [{
                    text: '取消',
                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                }, {
                    text: '确认',
                    onPress: () => this.refundApply(order,type),
                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                }]
            );
        }

    };
    refundApply(order,type,charge,chargeName){
        let refundName = "";
        if(chargeName == refundRuncharge){
            refundName = refundRun
        }else if(chargeName == goodsGetcharge){
            refundName = goodsOrderCancle
        }else{
            refundName = refund
        }
        if(type === 'change'){
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{id:order.id,}
            };
            changeCheck(params).then((res)=>{
                if(res.data.code === '0000'){
                    this.props.history.push('/selectShift',order)
                }else{
                    Toast.info(res.data.msg,3)
                }
            });
        }
        if(type === 'refund'){
            Toast.loading("正在加载",0);
            if(chargeName == goodsGetcharge){
                let params = {
                    source:1,
                    token: this.props.userInfo.token,
                    data:{id:order,charge:charge,cancleOperatorType:0,}
                };
                goodsOrderCancle(params).then((res)=>{
                    if(res.data.code === '0000'){
                        Toast.info("操作成功",this.props.paySuccess())
                    }else{
                        Toast.info(res.data.msg,3)
                    }
                });
            }else{
                let params = {
                    source:1,
                    token: this.props.userInfo.token,
                    data:{id:order,charge:charge}
                };
                refundName(params).then((res)=>{
                    if(res.data.code === '0000'){
                        Toast.info("操作成功",this.props.paySuccess())
                    }else if(res.data.code === '9999'){
                        // 修改弹窗提示
                        Toast.hide();
                        Modal.alert('提示',
                           (<div className="refundText">
                               <div className="refundBox noPadding">操作频繁,请稍后再试!</div>
                           </div>),
                           [{
                               text: '确认',
                               style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                           }]
                       );
                   }else{
                        Toast.info(res.data.msg,3)
                    }
                })
            }

        }
    }



    getImg(rowData){
        if(rowData.orderType == 1){
            return <img src={car}/>
        }
        if(rowData.orderType == 2){
            return <img src={cityCar}/>
        }
        if(rowData.orderType == 19){
            return <img src={baoche}/>
        }
        if(rowData.orderType == 5){
            return <img src={jiesong}/>
        }
    }
    getTitle(rowData){
        if(rowData.orderType == 1 && rowData.isChild == 0){
            return "预约出行订单"
        }
        if(rowData.orderType == 1 && rowData.isChild == 1){
            return <div>预约出行订单 <span style={{color:"#03B0C6"}}>儿童票</span></div>
        }
        if(rowData.orderType == 2){
            if(rowData.cityorderType == 0){
                return "实时订单"
            }
            if(rowData.cityorderType == 1){
                return "预约订单"
            }
        }
        if(rowData.orderType == 19){
            if(rowData.orderGenre == 0){
                return "单程包车"
            }
            if(rowData.orderGenre == 1){
                return "往返包车"
            }
            if(rowData.orderGenre == 2){
                return "按天包车"
            }
        }
        if(rowData.orderType == 5){
            return "接送站"
        }
        if(rowData.orderType == 7){
            return `订单号${rowData.orderNum}`
        }
    }
    //订单状态
    colorType(rowData){
        const type =rowData.status;
        if(rowData.orderType == 19){
            switch(type){
                case 0 :
                    return  <span style={{color:"#25C39E"}}>待审核</span>;
                case 1 :
                    return  <span style={{color:"#FF0000"}}>待付款</span>;
                case 2 :
                    return  <span style={{color:"#F79E24"}}>待出行</span>;
                case 3 :
                    return  <span style={{color:"#22BE28"}}>行程中</span>;
                case 4 :
                    return  <span style={{color:"#616372"}}>已完成</span>;
                case 98 :
                    return  <span style={{color:"#D9D9DE"}}>已退票</span>;
                case 99 :
                    return  <span style={{color:"#D9D9DE"}}>已取消</span>;
            }
        }else if(rowData.orderType == 1){
            switch(type){
                case 4 :
                    return  <span style={{color:"#FF0000"}}>待付款</span>;
                case 6 :
                    return  <span style={{color:"#F79E24"}}>待出行</span>;
                case 8 :
                    return  <span style={{color:"#22BE28"}}>行程中</span>;
                case 9 :
                    return  <span style={{color:"#616372"}}>已改签</span>;
                case 10 :
                    return  <span style={{color:"#D9D9DE"}}>已关闭</span>;
                case 11 :
                    return  <span style={{color:"#616372"}}>已完成</span>;
                case 12 :
                    return  <span style={{color:"#D9D9DE"}}>已退票</span>;
            }
        }else if(rowData.orderType == 2){
            switch(type){
                case 0 :
                    return  <span style={{color:"#25C39E"}}>未接单</span>;
                case 1: case 2: case 3:
                    return  <span style={{color:"#F79E24"}}>已接单</span>;
                case 4 :
                    return  <span style={{color:"#22BE28"}}>行程中</span>;
                case 6 :
                    return  <span style={{color:"#616372"}}>待司机确认</span>;
                case 7 :case 77 :
                    return  <span style={{color:"#FF0000"}}>待支付</span>;
                case 8 :
                    return  <span style={{color:"#616372"}}>已完成</span>;
                case 99 :
                    return  <span style={{color:"#D9D9DE"}}>已取消</span>;
            }
        }else if(rowData.orderType == 5){
            switch(type){
                case 0 :
                    return  <span style={{color:"#FF0000"}}>待支付</span>;
                case 1: case 2:
                return  <span style={{color:"#F79E24"}}>待出行</span>;
                case 3 :
                    return  <span style={{color:"#22BE28"}}>行程中</span>;
                case 4 :
                    return  <span style={{color:"#616372"}}>已完成</span>;
                case 98 :
                    return  <span style={{color:"#D9D9DE"}}>已退票</span>;
                case 99 :
                    return  <span style={{color:"#D9D9DE"}}>已关闭</span>;
            }
        }else if(rowData.orderType == 7){
            switch(type){
                case 0 :
                    return  <span style={{color:"#FF0000"}}>待支付</span>;
                case 1:
                return  <span style={{color:"#F79E24"}}>待出行</span>;
                case 2 :
                    return  <span style={{color:"#22BE28"}}>行程中</span>;
                case 3 :
                    return  <span style={{color:"#616372"}}>已完成</span>;
                case 98 :
                    return  <span style={{color:"#D9D9DE"}}>已退款</span>;
                case 99 :
                    return  <span style={{color:"#D9D9DE"}}>已关闭</span>;
            }
        }

    }
    statusType(rowData){
        if(rowData.orderType == 19){
            switch(rowData.status){
                case 0 :
                    return  <div className="goRefund" onClick={() =>  Modal.alert('提示',
                        (<div className="refundText">您是否确认取消？</div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                        }, {
                            text: '确认',
                            onPress: () => this.cancel(rowData),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                        }]
                    )}>取消订单</div>;
                case 1 :
                    return  <div className="pay" onClick={() => this.setState({payModal:true,payOrderId:rowData.id,payType:busWxPay})}>去支付</div>;

            }
        }else if(rowData.orderType == 1){
            switch(true){
                case rowData.status==4 :
                    return  <div className="pay" onClick={() => this.setState({payModal:true,payOrderId:rowData.id,payType:newWxPay})}>去支付</div>;
                case rowData.status==6 && rowData.isChild == 0:
                    return  <div className="goRefundBox">
                        <div className="goRefunds" onClick={() => this.goRefund(rowData.id,'refund',getRefundcharge)}>退票</div>
                        <div className="goRefund" onClick={() => this.goRefund(rowData,'change')}>改签</div>
                    </div>;
                case rowData.status==6 && rowData.isChild == 1:
                    return  <div className="goRefundBox">
                        <div className="goRefund" onClick={() => this.goRefund(rowData.id,'refund',getRefundcharge)}>退票</div>
                    </div>;
                case rowData.status==12 && rowData.isChild == 0:
                    return  <div className="goRefund" onClick={() => this.props.history.push("/refund",{orderId:rowData.id,tailoredType:1,})}>退款进度</div>;
            }
        }else if(rowData.orderType == 2){
            switch(rowData.status){
                case 7 : case 77 :
                    return  <div className="pay" onClick={() => this.props.history.push('/RideCarPay',{orderId:rowData.id})}>去支付</div>;
                case 0 : case 1 :
                    return  <div className="goRefund" onClick={() => Modal.alert('提示',
                        (<div className="refundText">您是否确认取消？</div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                        }, {
                            text: '确认',
                            onPress: () => this.cancelCity(rowData),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                        }]
                    )}>取消订单</div>;
               case 2 :case 3 :
                return  <div className="goRefund" onClick={() => {
                    let params = {
                        source:1,
                        token: this.props.userInfo.token,
                        data:{
                            shuntOrderid:rowData.id,
                        },
                    };
                    getCancelPic(params).then((res)=>{
                        if(res.data.code == "0000"){
                            Modal.alert('提示',
                                (<div className="refundText">
                                    <div>您是否确认取消？</div>
                                    <div style={{color:"#616372",fontWeight:"initial"}}>本次主动取消订单将收取  <span style={{color:"#F79E24"}}>{res.data.data + "元"}</span>手续费 </div>
                                </div>),
                                [{
                                    text: '取消',
                                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                }, {
                                    text: '确认',
                                    onPress: () => this.cancelCity(rowData,res.data.data),
                                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                }]
                            )
                        }
                    });

                }}>取消订单</div>;
            }
        }else if(rowData.orderType == 5){
            switch(rowData.status){
                case 0 :
                    return  <div className="pay" onClick={() => this.setState({payModal:true,payOrderId:rowData.id,payType:shuttlePay})}>去支付</div>;
                case 1 : case 2 :
                    return  <div className="goRefund" onClick={() =>  Modal.alert('提示',
                        (<div className="refundText">确认放弃本次出行？</div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                        }, {
                            text: '确认',
                            onPress: () => this.goRefund(rowData.id,'refund',refundRuncharge),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                        }]
                    )}>退款</div>;
                case 98:
                    return  <div className="goRefund" onClick={() => this.props.history.push("/refund",{orderId:rowData.id,tailoredType:5,})}>退款进度</div>;
            }
        }else if(rowData.orderType == 7){
            switch(rowData.status){
                case 0 :
                    return  <div className="pay" onClick={() => this.setState({payModal:true,payOrderId:rowData.id,payType:goodsPay})}>去支付</div>;
                case 1 :
                    return  <div className="goRefund" onClick={() => this.goRefund(rowData.id,'refund',goodsGetcharge)}>退款</div>;
            }
        }
    }
    //取消城内订单
    cancelCity(rowData,pic){
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                operatorType:0,//操作员类型:0-乘客1-调度2-后台管理取消
                shuntOrderid:rowData.id,
                serviceCharge:pic,
            }
        };
        Toast.loading("",30);
        cancelCityOrder(params).then((res)=>{
            if(res.data.code == "0000"){
                if(res.data.data.totalPrice > 0){
                    this.props.history.push('/rideCar',{orderId:rowData.id});
                }else{
                    Toast.info("取消成功",this.props.paySuccess());
                }
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    cancel(rowData){
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                id:rowData.id,
            },
        };
        cancelOrder(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("取消成功",this.props.paySuccess());
            }else{
                Toast.info(res.data.msg,3)
            }
        })

    }
    getTime(rowData){
        if(rowData.orderType == 1){
            return '接人时间'+rowData.pickUpTime
        } else if(rowData.orderType == 19){
            return  rowData.passengerNum+'人'
        }
    }
    onClose = () => {
        this.setState({payModal:false,});
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                source:3,
            }
        };
        walletCode(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setDownTime(60);
                this.setState({codeModal:true});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        this.setState({codeModal:false,});
        this.goPay("wallet",v);
    }

    render() {
        const {rowData} = this.props;
        return (
            <div className="orderListItem" /* key={rowData.id} */ >
                 <div className="header" onClick={() => this.goDetail(rowData.id, rowData.orderType)}>
                    <div>{this.getImg(rowData)}</div>
                    <div className="orderNumber">{this.getTitle(rowData)}</div>
                    <div className="orderType">{this.colorType(rowData)}</div>
                </div>
                {
                    rowData.orderType == 7 ? <div className="box" onClick={() => this.goDetail(rowData.id, rowData.orderType)}>
                        <div><span  style={{fontSize:'12px'}}>行程订单号：{rowData.shiftNum}</span></div>
                        <div className="endBox"><i className="icon iconfont iconshijian" /><span>{rowData.startTime}{rowData.startCity}-{rowData.endCity}</span></div>
                        <div className="endBox">
                            <i className="icon iconfont iconhuowudingdan" />
                            <span className="address">{rowData.logisticsType}{rowData.logisticsWeight+"kg"}</span>
                        </div>
                    </div>:
                        <div className="box" onClick={() => this.goDetail(rowData.id, rowData.orderType)}>
                            <div><span style={{fontSize:'12px'}}>行程订单号：{rowData.shiftNum}</span></div>
                            <div className="endBox"><i className="icon iconfont iconshijian" /><span>{rowData.startDate} {rowData.startTime} {this.getTime(rowData)}</span></div>
                            <div className="endBox">
                                <i className="icon iconfont iconchufadi" />
                                <span className="address"> {rowData.orderType == 19 || rowData.orderType == 5 ? rowData.startCity : rowData.startCity+"."+rowData.startAddress}</span>
                            </div>

                            <div className="endBox">
                                <i className="icon iconfont iconmudedi" />
                                <span className="address">{rowData.orderType == 19 || rowData.orderType == 5 ? rowData.endCity : rowData.endCity+"."+rowData.endAddress}</span>
                            </div>
                        </div>
                }



                <div className="footer">
                    <div></div>
                    {/*{rowData.isEstimated == 0 ? <div className="pay" onClick={() => this.star(rowData)}>评价</div> : null}
                    <div className="goRefund" onClick={() => this.goRefund(rowData.orderNum,'refund')}>退款</div>
                    <div className="goRefund" onClick={() => this.goRefund(rowData.orderNum,'change')}>改签</div>*/}

                    {this.statusType(rowData)}

                </div>
                <PayModal
                    {...this.props}
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                    businessType={rowData.orderType == 1 ? "intercity" : undefined}
                    // balance={this.props.balance}
                />
                {this.payFrom()}
                <TestCode
                    modal={this.state.codeModal}
                    onClose={()=>this.setState({codeModal:false})}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/OrderListItem/index.js